import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
/**
 * Notification service. Used for showing toast messages in UI.
 */
export class NotificationService {

  /**
   * Constructor
   * @param toastr Toast service instance.
   */
  constructor(private toastr: ToastrService) { }

  /**
   * Show success toast
   * @param message Message to display
   * @param title Title of toast
   */
  showSuccess(message: string | "", title: string | ""){
      this.toastr.success(message, title, {closeButton : true})
  }

  /**
   * Show error toast
   * @param message Message to display
   * @param title Title of toast
   */
  showError(message: string | "", title: string | ""){
      this.toastr.error(message, title, {closeButton : true})
  }

  /**
   * Show information toast
   * @param message Message to display
   * @param title Title of toast
   */
  showInfo(message: string | "", title: string | ""){
      //this.toastr.info(message, title, {closeButton : true})
  }

  /**
   * Show warning toast
   * @param message Message to display
   * @param title Title of toast
   */
  showWarning(message: string | "", title: string | ""){
      this.toastr.warning(message, title, {closeButton : true})
  }

}
